module.exports = __webpack_public_path__ + "025c5f5272bebdc6e0976fb365e7a2e8.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/bella-flowy-tank-grey.png
// module id = 826
// module chunks = 0